import Footer from "./components/Footer";
import Header from "./components/Header";
import CredentialsGrid from "./components/CredentialsGrid";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import CredentialPage from "./components/CredentialPage";
import { CredentialsProvider } from "./context/CredentialsContext";
import CreateCredential from "./components/CreateCredential";
import AuthPage from "./components/AuthPage";
import PasswordResetPage from "./components/PasswordResetPage";
import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from "./context/AuthContext";
import AuditPage from "./components/AuditPage";
import InvitationsPage from "./components/InvitationsPage";
import CreateInvitation from "./components/CreateInvitation";
import ExpirationManagement from "./components/ExpirationManagement";
import EmailVerificationBanner from "./components/EmailVerificationBanner";
import ProfilePage from "./components/ProfilePage";
import DataDeletionRequest from "./components/DataDeletionRequest";
import DataDeletionManagement from "./components/DataDeletionManagement";
import StaffInvitationsPage from "./components/StaffInvitationsPage";
import "./styles/brand.css";

function App() {
    return (
        <Router>
            <AuthProvider>
                <CredentialsProvider>
                    <div className="app-layout">
                    <Header />
                    <div className="app-content">
                    <EmailVerificationBanner />
                    <Routes>
                        <Route path="/auth" element={<AuthPage />} />
                        <Route path="/auth/forgot-password" element={<PasswordResetPage />} />
                        <Route path="/auth/reset-password" element={<PasswordResetPage reset />} />
                        <Route
                            path="/data-deletion-request"
                            element={<DataDeletionRequest />}
                        />
                        <Route
                            path="/"
                            element={
                                <RequireAuth>
                                    <Home />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/credential/:credentialID"
                            element={
                                <RequireAuth>
                                    <CredentialPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/create"
                            element={
                                <RequireAuth>
                                    <CreateCredential />
                                </RequireAuth>
                            }
                        ></Route>
                        <Route
                            path="/audit"
                            element={
                                <RequireAuth>
                                    <AuditPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/invitations"
                            element={
                                <RequireAuth requiredRole="internal_staff">
                                    <InvitationsPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/invitations/create"
                            element={
                                <RequireAuth requiredRole="internal_staff">
                                    <CreateInvitation />
                                </RequireAuth>
                            }
                        />
                        <Route path="/staff/invitations" element={
                            <RequireAuth requiredRole="internal_staff"><StaffInvitationsPage /></RequireAuth>
                        } />
                        <Route
                            path="/expiration-management"
                            element={
                                <RequireAuth requiredRole="internal_staff">
                                    <ExpirationManagement />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <RequireAuth>
                                    <ProfilePage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/data-deletion-management"
                            element={
                                <RequireAuth requiredRole="internal_staff">
                                    <DataDeletionManagement />
                                </RequireAuth>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    </div>
                    <Footer />
                    </div>
                </CredentialsProvider>
            </AuthProvider>
        </Router>
    );
}

//setup page route functions
function Home() {
    return (
        <main className="main-shell">
            <div className="content-shell">
                <section className="vault-heading">
                    <p className="eyebrow">ACCREDITATION WORKSPACE</p>
                    <h1>Your credentials</h1>
                    <p>Find and manage customer logins in one place.</p>
                    <details className="vault-guidance">
                        <summary>Keep passwords here. Share a link in CRM. <span>How it works</span></summary>
                        <p>Store passwords only in this app, never in documents, emails or CRM fields.
                            Copy the credential’s page link into CRM instead. Only people with the
                            appropriate app access can view it.</p>
                    </details>
                </section>

                <section className="list-card">
                    <CredentialsGrid />
                </section>
            </div>
        </main>
    );
}

export default App;
